import React, { useEffect, useState } from "react";
import Modal from 'react-modal';

import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import HttpLinkServices from "../../services/HttpLinkServices";
import gql from "graphql-tag";
import './styles.css';

import AccountService from "../../services/AccountService";
import logoPortoEduc from "../../assets/img/logoPortoEduc.png";
import { toast } from 'react-toastify'

const accountServices = new AccountService();
const customStyles = {
  content : {
    height        : '100%',
    top           : '0',
    left          : '30%',
    right         : '0',
    paddingLeft   : '10%',
    paddingTop    : '5%',
    paddingRight  : '29.5%',
  }
};

const account_client = new ApolloClient({
  link: HttpLinkServices.account,
  cache: new InMemoryCache(),
});

const LGPD_GET_CONSENTIMENTO = gql`
  query getConsentimento($cpf: String!) {
    lgpd_consulta_consentimento(cpf: $cpf)
  }
`;

const LGPD_SET_CONSENTIMENTO = gql`
  mutation setConsentimento($cpf: String!, $nome: String!) {
    lgpd_definir_consentimento(cpf: $cpf, nome:$nome)
  }
`;

export function Consentimento() {
  const [ modalIsOpen, setIsOpen ] = useState(false);

  useEffect(() => {
    async function validaExibicaoModalConsentimento() {
      const userResponse = await accountServices.getAuthenticatedUser();

      account_client.query({
        variables: {
          cpf: userResponse.data.get_authenticated_user.uid
        },
        query: LGPD_GET_CONSENTIMENTO
      }).then(result => {
        if (!result.data.lgpd_consulta_consentimento) {
          setIsOpen(true);
        }
      });
    }

    validaExibicaoModalConsentimento();
  }, []);

  async function closeModal(){
    const userResponse = await accountServices.getAuthenticatedUser();
    const cpf = userResponse.data.get_authenticated_user.uid;
    const nome = userResponse.data.get_authenticated_user.name;

    if (cpf) {
      account_client.mutate({
        mutation: LGPD_SET_CONSENTIMENTO,
        variables: { cpf, nome }
      }).then(() => setIsOpen(false))
      .catch(() => toast.error("Ocorreu um erro no envio dos termos!"));
    } else {
      toast.error("Ocorreu um erro no aceite dos termos!");
    }
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      shouldCloseOnOverlayClick={false}
    >
      <img className="logo_top_modal" alt= "Logo PortoEduc" src={logoPortoEduc} />
        <br />
      <h2 className="titulo_modal">Nossos Termos de Uso e Política de Privacidade mudaram.</h2>
      <p>
          Para continuar usando o Porto Educ, você precisa aceitar a atualização das nossas políticas. <br/>Você pode ver o que mudou no link abaixo:
      </p>
      <div className="links_modal">
        <a className="termos" target="_blank" href="https://www.portoseguro.com.br/privacidade">Política de Privacidade</a>
      </div>
      <button className="aceite_modal" onClick={closeModal}> Entendi e aceito </button>

    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/components/Consentimento/index.js